import {
  AdminLoginResDto,
  CurrentOrganizationResDto,
} from "../../api/estabrookSchemas";

export type SessionRole = AdminLoginResDto["role"];

/**
 * Multi-tenancy context for the signed-in session. The generated schema types
 * `organizationId` and `impersonatedBy` as `Record<string, any> | null` because
 * the OpenAPI spec leaves them untyped; the API sends UUID strings. Narrowed
 * here so call sites don't each have to cast.
 */
export interface Session {
  organizationId: string | null;
  organization: CurrentOrganizationResDto | null;
  role: SessionRole | null;
  isImpersonating: boolean;
  impersonatedBy: string | null;
}

export const emptySession: Session = {
  organizationId: null,
  organization: null,
  role: null,
  isImpersonating: false,
  impersonatedBy: null,
};

export const sessionFromLoginRes = (dto: AdminLoginResDto): Session => ({
  organizationId: (dto.organizationId as string | null) ?? null,
  organization: dto.organization ?? null,
  role: dto.role ?? null,
  isImpersonating: dto.isImpersonating ?? false,
  impersonatedBy: (dto.impersonatedBy as string | null) ?? null,
});
